import { apiCar } from '@/services/api-config';

export default async function (carCode: string) {
  return apiCar
    .get(carCode, {
      params: {
        IAMKEY: 'B0A1C8F78547A12FE164672D5C3FCD5CFE0C216E8EC920B28739ECC78EA414F7',
      },
    })
    .then((response) => response.data)
    .catch(() => false);
}
